import React from 'react';
import { theme } from 'antd';
import CustomSelect from 'components/CustomSelect';
import TitleBar from 'components/TitleBar';
import HierarchicalTree from 'components/HierarchicalTrees/HierarchicalTree';
import { HierarchicalTreeProps } from 'store/ducks/Global/types';
import { useTranslation } from 'react-i18next';
import * as Styled from './Tree.styled';

const { useToken } = theme;

const HierarchicalTreePage: React.FC<HierarchicalTreeProps> = ({
  title,
  data,
  entityOptions,
  selectedEntityId,
  setSelectedEntityId,
  onDateChange,
  buildTree,
}) => {
  const { token } = useToken();
  const { t } = useTranslation();
  return (
    <Styled.StyledLayout token={token}>
      <TitleBar title={title} />
      <Styled.CustomSelectComponent>
        <Styled.FilterItem>
          <Styled.FilterLabel>{t('GENERAL.SELECT_ENTITY')}</Styled.FilterLabel>
          <CustomSelect
            allowClear
            showSearch
            options={entityOptions}
            value={selectedEntityId}
            onChange={setSelectedEntityId}
            filterOption={(input: string, option?: { label: string }) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
          />
        </Styled.FilterItem>

        <Styled.FilterItem>
          <Styled.FilterLabel>
            {t('REPORTING.SELECT_REPORTING_DATE')}
          </Styled.FilterLabel>
          <Styled.SmallDatePicker
            onChange={(_, dateString) => {
              if (typeof dateString === 'string') {
                onDateChange(dateString);
              }
            }}
          />
        </Styled.FilterItem>
      </Styled.CustomSelectComponent>

      <Styled.HorizontalLayoutMain theme={{}}>
        <Styled.TreeWrapper token={token as any}>
          <HierarchicalTree data={data} buildTree={buildTree} />
        </Styled.TreeWrapper>
      </Styled.HorizontalLayoutMain>
    </Styled.StyledLayout>
  );
};

export default HierarchicalTreePage;
